import {IHttpService} from "angular";
import {IsoDate} from "../../pseudo-types/DateTypes";
import {AccountTransactionRecords} from "../types/AccountTransactionRecord";
import {AccountId} from "../types/AccountRecord";

export class AccountTransactionsService {

    public static readonly id = "accountTransactionsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async list(accountId: AccountId,
                      fromDate: IsoDate,
                      toDate: IsoDate | null): Promise<AccountTransactionRecords> {
        const url = `/tradefloor/api/account-cash-ledger/${accountId}`;
        const params = { fromDate, toDate };
        const response = await this.$http.get<AccountTransactionRecords>(url, {params});
        return response.data;
    }
}
